import React from "react"
import { NavLink } from "react-router-dom";

import dsd from "../classes/clsDSD";

import * as PD from '../classes/pdStyle';
import { userService } from '../auth/_services/user.service';
import packageJson from '../../package.json';
import logo from '../images/dsd_logo_colour_network.png';

import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';
import { isNull, isEqual, isArray } from "lodash";

import { getSolution } from "../utils/utilsSolution";
import { getConceptModel } from "../utils/utilsConceptModel";
import { getLogicalModel } from "../utils/utilsLogicalModel";
import { getDataDictionary } from "../utils/utilsDataDictionary";
import { getDataSpec } from "../utils/utilsDataSpec";
import { getInterface } from "../utils/utilsInterface";
import { getProcess } from "../utils/utilsProcess";
import { getDesign } from "../utils/utilsDesign";
import { getCodeList } from "../utils/utilsCodeList";
import { getNarrative } from "../utils/utilsNarrative";
import { listVersions } from "../utils/utilsVersion";

class DesignerContainer extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            LayoutContent:null,
            user:null
        }

        this.dsd = new dsd();

        this.setLayoutContent = this.setLayoutContent.bind(this);
        this.setUser = this.setUser.bind(this);

    }


    setLayoutContent(content){

        if (!isEqual(content, this.state.LayoutContent)){
            this.setState({LayoutContent:content});
        }
    }

    setLeftAsConceptModel(id){
        if (id){            
            const onLoad = (ConceptModel) => {
                this.loadLeftConceptModel(ConceptModel)
            };                        
            getConceptModel(this.dsd, id, onLoad);
        }
    }

    setLeftAsConceptModelVersions(id){
        if (id){            
            const onLoad = (ConceptModel) => {
                listVersions(this.dsd, {idAbout:id}, (Versions) => {
                    this.loadLeftConceptModelVersions(ConceptModel, Versions)
                });
            };                        
            getConceptModel(this.dsd, id, onLoad);
        }
    }



    setLeftAsLogicalModel(id){
        if (id){            
            const onLoad = (LogicalModel) => {
                this.loadLeftLogicalModel(LogicalModel)
            };                        
            getLogicalModel(this.dsd, id, onLoad);
        }

    }

    setLeftAsLogicalModelVersions(id){
        if (id){            
            const onLoad = (LogicalModel) => {
                listVersions(this.dsd, {idAbout:id}, (Versions) => {
                    this.loadLeftLogicalModelVersions(LogicalModel, Versions)
                });
            };                        
            getLogicalModel(this.dsd, id, onLoad);
        }
    }



    setLeftAsDataDictionary(id){
        if (id){            
            const onLoad = (DataDictionary) => {
                this.loadLeftDataDictionary(DataDictionary)
            };                        
            getDataDictionary(this.dsd, id, onLoad);
        }

    }

    setLeftAsDataDictionaryVersions(id){
        if (id){            
            const onLoad = (DataDictionary) => {
                listVersions(this.dsd, {idAbout:id}, (Versions) => {
                    this.loadLeftDataDictionaryVersions(DataDictionary, Versions)
                });
            };                        
            getDataDictionary(this.dsd, id, onLoad);
        }
    }


    setLeftAsDataSpec(id){
        if (id){            
            const onLoad = (DataSpec) => {
                this.loadLeftDataSpec(DataSpec)
            };                        
            getDataSpec(this.dsd, id, onLoad);
        }
    }


    setLeftAsInterface(id){
        if (id){            
            const onLoad = (Interface) => {
                this.loadLeftInterface(Interface)
            };                        
            getInterface(this.dsd, id, onLoad);
        }

    }

    setLeftAsSolution(id){
        if (id){            
            const onLoad = (Solution) => {
                this.loadLeftSolution(Solution)
            };                        
            getSolution(this.dsd, id, onLoad);
        }
    }


    setLeftAsSolutionVersions(id){
        if (id){            
            const onLoad = (Solution) => {
                listVersions(this.dsd, {idAbout:id}, (Versions) => {
                    this.loadLeftSolutionVersions(Solution, Versions)
                });
            };                        
            getSolution(this.dsd, id, onLoad);
        }
    }



    setLeftAsDesign(id){
        if (id){            
            const onLoad = (Design) => {
                this.loadLeftDesign(Design)
            };                        
            getDesign(this.dsd, id, onLoad);
        }

    }


    setLeftAsProcess(id){
        if (id){            
            const onLoad = (Process) => {
                this.loadLeftProcess(Process)
            };                        
            getProcess(this.dsd, id, onLoad);
        }
    }

    setLeftAsCodeList(id, offset=0){
        if (id){
            const onLoad = (CodeList) => {
                this.loadLeftCodeList(CodeList, offset)
            };
            getCodeList(this.dsd, id, onLoad);
        }
    }

    setLeftAsCodeListVersions(id){
        if (id){            
            const onLoad = (CodeList) => {
                listVersions(this.dsd, {idAbout:id}, (Versions) => {
                    this.loadLeftCodeListVersions(CodeList, Versions)
                });
            };                        
            getCodeList(this.dsd, id, onLoad);
        }
    }


    setLeftAsNarrative(id){
        if (id){            
            const onLoad = (Narrative) => {
                this.loadLeftNarrative(Narrative)
            };                        
            getNarrative(this.dsd, id, onLoad);
        }

    }

    setLeftAsNarrativeVersions(id){
        if (id){            
            const onLoad = (Narrative) => {
                listVersions(this.dsd, {idAbout:id}, (Versions) => {
                    this.loadLeftNarrativeVersions(Narrative, Versions)
                });
            };                        
            getNarrative(this.dsd, id, onLoad);
        }
    }



    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }

    loadLeftConceptModel(ConceptModel){

        let Content = {Index:{}};

        if (ConceptModel){
            Content.Index.type = 'Concept Model';
            Content.Index.title = ConceptModel.name;
            Content.Index.link = `/conceptmodel/${ConceptModel._id}`

            Content.Index.Sections = [];

            if (ConceptModel.Concepts){
                let Section = {title:"Concepts"}
                Section.Items = [];
                for (let posI=0;posI<ConceptModel.Concepts.length; posI++){
                    let Concept = ConceptModel.Concepts[posI];

                    switch (Concept.status){
                        case 'deprecated':
                            break;
                        default:

                            let Item = {}
                            Item.label = Concept.name;
                            Item.link = `/concept/${Concept._id}`
                            Section.Items.push(Item);
                            break;
                    }
                }
                Content.Index.Sections.push(Section);
            }

            if (ConceptModel.Links){
                let Section = {title:"Links"}
                Section.Items = [];
                for (let posI=0;posI<ConceptModel.Links.length; posI++){
                    let Link = ConceptModel.Links[posI];

                    switch (Link.status){
                        case 'deprecated':
                            break;
                        default:

                            let Item = {}
                            Item.label = Link.name;
                            Item.link = `/link/${Link._id}`
                            Section.Items.push(Item);
                            break;
                    }
                }
                Content.Index.Sections.push(Section);
            }
        }

        this.setLayoutContent(Content)
        localStorage.setItem("dsdContent",JSON.stringify(Content));

        return;

    }

    loadLeftConceptModelVersions(ConceptModel, Versions){

        let Content = {Index:{}};

        if (ConceptModel){
            Content.Index.type = 'Concept Model';
            Content.Index.title = ConceptModel.name;
            Content.Index.link = `/conceptmodel/${ConceptModel._id}`

            Content.Index.Sections = [];
            if (Versions){
                let Section = {title: "Versions"};
                Section.Items = [];

                for (const Version of Versions){
                    let Item = {};
                    Item.label = Version.name;
                    Item.link = `/conceptmodel/${ConceptModel._id}/version/${Version._id}`;
                    Section.Items.push(Item);
                }

                Content.Index.Sections.push(Section);
            }
        }

        this.setLayoutContent(Content)
        localStorage.setItem("dsdContent",JSON.stringify(Content));

        return;

    }


    loadLeftLogicalModel(LogicalModel){

        let Content = {Index:{}};

        if (LogicalModel){
            Content.Index.type = 'Logical Model';
            Content.Index.title = LogicalModel.name;
            Content.Index.link = `/logicalmodel/${LogicalModel._id}`

            Content.Index.Sections = [];

            if (LogicalModel.Entities){
                let Section = {title:"Entities"}
                Section.Items = [];
                for (let posI=0;posI<LogicalModel.Entities.length; posI++){
                    let Entity = LogicalModel.Entities[posI];

                    switch (Entity.status){
                        case 'deprecated':
                            break;
                        default:

                            let Item = {}
                            Item.label = Entity.name;
                            Item.link = `/entity/${Entity._id}`
                            Section.Items.push(Item);
                            break;
                    }
                }
                Content.Index.Sections.push(Section);
            }

            if (LogicalModel.Relationships){
                let Section = {title:"Relationships"}
                Section.Items = [];
                for (let posI=0;posI<LogicalModel.Relationships.length; posI++){
                    let Relationship = LogicalModel.Relationships[posI];

                    switch (Relationship.status){
                        case 'deprecated':
                            break;
                        default:

                            let Item = {}
                            Item.label = '-';
                            if (Relationship.Link){
                                Item.label = `${Relationship.EntityFrom.name} ${Relationship.Link.label} ${Relationship.EntityTo.name}`;
                                if (Relationship.inverse){
                                    Item.label = `${Relationship.EntityFrom.name} ${Relationship.Link.inverseLabel} ${Relationship.EntityTo.name}`;
                                }
                            }

                            Item.link = `/relationship/${Relationship._id}`
                            Section.Items.push(Item);
                            break;
                    }
                }
                Content.Index.Sections.push(Section);
            }

        }

        this.setLayoutContent(Content)
        localStorage.setItem("dsdContent",JSON.stringify(Content));

        return;

    }

    loadLeftLogicalModelVersions(LogicalModel, Versions){

        let Content = {Index:{}};

        if (LogicalModel){
            Content.Index.type = 'Logical Model';
            Content.Index.title = LogicalModel.name;
            Content.Index.link = `/logicalmodel/${LogicalModel._id}`

            Content.Index.Sections = [];
            if (Versions){
                let Section = {title: "Versions"};
                Section.Items = [];

                for (const Version of Versions){
                    let Item = {};
                    Item.label = Version.name;
                    Item.link = `/logicalmodel/${LogicalModel._id}/version/${Version._id}`;
                    Section.Items.push(Item);
                }

                Content.Index.Sections.push(Section);
            }
        }

        this.setLayoutContent(Content)
        localStorage.setItem("dsdContent",JSON.stringify(Content));

        return;

    }

    loadLeftDataDictionary(DataDictionary){

        let Content = {Index:{}};

        if (DataDictionary){
            Content.Index.type = 'Data Dictionary';
            Content.Index.title = DataDictionary.name;
            Content.Index.link = `/datadictionary/${DataDictionary._id}`

            Content.Index.Sections = [];

            if (DataDictionary.Structures){
                let Section = {title:"Structures"}
                Section.Items = [];
                for (let posI=0;posI<DataDictionary.Structures.length; posI++){
                    let Structure = DataDictionary.Structures[posI];

                    switch (Structure.status){
                        case 'deprecated':
                            break;
                        default:

                            let Item = {}
                            Item.label = Structure.name;
                            Item.link = `/structure/${Structure._id}`
                            Section.Items.push(Item);
                            break;
                    }
                }
                Content.Index.Sections.push(Section);
            }

            if (DataDictionary.Enumerations){
                let Section = {title:"Enumerations"}
                Section.Items = [];
                for (let posI=0;posI<DataDictionary.Enumerations.length; posI++){
                    let Enumeration = DataDictionary.Enumerations[posI];

                    switch (Enumeration.status){
                        case 'deprecated':
                            break;
                        default:

                            let Item = {}
                            Item.label = Enumeration.name;
                            Item.link = `/enumeration/${Enumeration._id}`
                            Section.Items.push(Item);
                            break;
                    }
                }
                Content.Index.Sections.push(Section);
            }

        }

        this.setLayoutContent(Content)
        localStorage.setItem("dsdContent",JSON.stringify(Content));

        return;

    }

    loadLeftDataDictionaryVersions(DataDictionary, Versions){

        let Content = {Index:{}};

        if (DataDictionary){
            Content.Index.type = 'Data Dictionary';
            Content.Index.title = DataDictionary.name;
            Content.Index.link = `/datadictionary/${DataDictionary._id}`

            Content.Index.Sections = [];
            if (Versions){
                let Section = {title: "Versions"};
                Section.Items = [];

                for (const Version of Versions){
                    let Item = {};
                    Item.label = Version.name;
                    Item.link = `/datadictionary/${DataDictionary._id}/version/${Version._id}`;
                    Section.Items.push(Item);
                }

                Content.Index.Sections.push(Section);
            }
        }

        this.setLayoutContent(Content)
        localStorage.setItem("dsdContent",JSON.stringify(Content));

        return;

    }


    loadLeftDataSpec(DataSpec){

        let Content = {Index:{}};

        if (DataSpec){
            Content.Index.type = 'Data Specification';
            Content.Index.title = DataSpec.name;
            Content.Index.link = `/dataspec/${DataSpec._id}`

            Content.Index.Sections = [];

            if (DataSpec.Classes){
                let Section = {title:"Classes"}
                Section.Items = [];
                for (let posI=0;posI<DataSpec.Classes.length; posI++){
                    let Class = DataSpec.Classes[posI];

                    switch (Class.status){
                        case 'deprecated':
                            break;
                        default:

                            let Item = {}
                            Item.label = Class.name;
                            Item.link = `/class/${Class._id}`
                            Section.Items.push(Item);
                            break;
                    }
                }
                Content.Index.Sections.push(Section);
            }

            if (DataSpec.Serializations){
                let Section = {title:"Serializations"}
                Section.Items = [];
                for (let posI=0;posI<DataSpec.Serializations.length; posI++){
                    let Serialization = DataSpec.Serializations[posI];

                    switch (Serialization.status){
                        case 'deprecated':
                            break;
                        default:

                            let Item = {}
                            Item.label = Serialization.name;
                            Item.link = `/serialization/${Serialization._id}`
                            Section.Items.push(Item);
                            break;
                    }
                }
                Content.Index.Sections.push(Section);
            }

        }

        this.setLayoutContent(Content)
        localStorage.setItem("dsdContent",JSON.stringify(Content));

        return;

    }

    loadLeftInterface(Interface){

        let Content = {Index:{}};

        if (Interface){
            Content.Index.type = 'Interface';
            Content.Index.title = Interface.name;
            Content.Index.link = `/interface/${Interface._id}`

            Content.Index.Sections = [];

            if (Interface.Parameters){
                let Section = {title:"Parameters"}
                Section.Items = [];
                for (let posI=0;posI<Interface.Parameters.length; posI++){
                    let Parameter = Interface.Parameters[posI];

                    switch (Parameter.status){
                        case 'deprecated':
                            break;
                        default:

                            let Item = {}
                            Item.label = Parameter.name;
                            Item.link = `/parameter/${Parameter._id}`
                            Section.Items.push(Item);
                            break;
                    }
                }
                Content.Index.Sections.push(Section);
            }

            if (Interface.Methods){
                let Section = {title:"Methods"}
                Section.Items = [];
                for (let posI=0;posI<Interface.Methods.length; posI++){
                    let Method = Interface.Methods[posI];

                    switch (Method.status){
                        case 'deprecated':
                            break;
                        default:

                            let Item = {}
                            Item.label = Method.name;
                            Item.link = `/method/${Method._id}`
                            Section.Items.push(Item);
                            break;
                    }
                }
                Content.Index.Sections.push(Section);
            }

        }

        this.setLayoutContent(Content)
        localStorage.setItem("dsdContent",JSON.stringify(Content));

        return;

    }


    loadLeftSolution(Solution){

        let Content = {Index:{}};

        if (Solution){
            Content.Index.type = 'Solution';
            Content.Index.title = Solution.name;
            Content.Index.link = `/solution/${Solution._id}`

            Content.Index.Sections = [];

            if (Solution.Roles){
                let Section = {title:"Roles"}
                Section.Items = [];
                for (let posI=0;posI<Solution.Roles.length; posI++){
                    let Role = Solution.Roles[posI];

                    switch (Role.status){
                        case 'deprecated':
                            break;
                        default:

                            let Item = {}
                            Item.label = Role.name;
                            Item.link = `/role/${Role._id}`
                            Section.Items.push(Item);
                            break;
                    }
                }
                Content.Index.Sections.push(Section);
            }


            if (Solution.Systems){
                let Section = {title:"Systems"}
                Section.Items = [];
                for (let pos=0;pos<Solution.Systems.length; pos++){
                    let System = Solution.Systems[pos];

                    switch (System.status){
                        case 'deprecated':
                            break;
                        default:

                            let Item = {}
                            Item.label = System.name;
                            Item.link = `/system/${System._id}`
                            Section.Items.push(Item);
                            break;
                    }
                }
                Content.Index.Sections.push(Section);
            }


            if (Solution.Capabilities){
                let Section = {title:"Capabilities"}
                Section.Items = [];
                for (let posI=0;posI<Solution.Capabilities.length; posI++){
                    let Capability = Solution.Capabilities[posI];

                    switch (Capability.status){
                        case 'deprecated':
                            break;
                        default:

                            let Item = {}
                            Item.label = Capability.name;
                            Item.link = `/capability/${Capability._id}`
                            Section.Items.push(Item);
                            break;
                    }
                }
                Content.Index.Sections.push(Section);
            }


            if (Solution.Participations){
                let Section = {title:"Participations"}
                Section.Items = [];
                for (let posC=0;posC<Solution.Participations.length; posC++){
                    let Participation = Solution.Participations[posC];

                    switch (Participation.status){
                        case 'deprecated':
                            break;
                        default:

                            let Item = {}

                            let Role = null;
                            if (Participation.idRole){
                                Role = Solution.Roles.find(role => role._id === Participation.idRole);
                            }


                            let Capability = null;
                            if (Participation.idCapability){
                                Capability = Solution.Capabilities.find(cap => cap._id === Participation.idCapability);
                            }

                            Item.label = `${Role ? Role.name +' ' : ''}${Participation.name}${Capability ? ' '+Capability.name : ''}`;
                            Item.link = `/participation/${Participation._id}`
                            Section.Items.push(Item);
                            break;
                    }
                }
                Content.Index.Sections.push(Section);
            }
        }

        this.setLayoutContent(Content)
        localStorage.setItem("dsdContent",JSON.stringify(Content));

        return;

    }


    loadLeftSolutionVersions(Solution, Versions){

        let Content = {Index:{}};

        if (Solution){
            Content.Index.type = 'Solution';
            Content.Index.title = Solution.name;
            Content.Index.link = `/solution/${Solution._id}`

            Content.Index.Sections = [];
            if (Versions){
                let Section = {title: "Versions"};
                Section.Items = [];

                for (const Version of Versions){
                    let Item = {};
                    Item.label = Version.name;
                    Item.link = `/solution/${Solution._id}/version/${Version._id}`;
                    Section.Items.push(Item);
                }

                Content.Index.Sections.push(Section);
            }
        }

        this.setLayoutContent(Content)
        localStorage.setItem("dsdContent",JSON.stringify(Content));

        return;

    }

    loadLeftDesign(Design){

        let Content = {Index:{}};

        if (Design){
            Content.Index.type = 'Design';
            Content.Index.title = Design.name;
            Content.Index.link = `/design/${Design._id}`

            Content.Index.Sections = [];

            if (Design.DesignItems){
                let Section = {title:"Design Items"}
                Section.Items = [];
                for (let posI=0;posI<Design.DesignItems.length; posI++){
                    let DesignItem = Design.DesignItems[posI];

                    switch (DesignItem.status){
                        case 'deprecated':
                            break;
                        default:

                            let Item = {}
                            Item.label = DesignItem.name;
                            Item.link = `/designitem/${DesignItem._id}`
                            Section.Items.push(Item);
                            break;
                    }
                }
                Content.Index.Sections.push(Section);
            }

        }

        this.setLayoutContent(Content)
        localStorage.setItem("dsdContent",JSON.stringify(Content));

        return;

    }


    loadLeftProcess(Process){

        let Content = {Index:{}};

        if (Process){
            Content.Index.type = 'Process';

            const onLoad = (ProcessLayout) => {
                let Section = {title:"Steps"}
                Section.Items = [];

                for (const entry of ProcessLayout){
                    let dotNode = entry.idNode;

                    let Item = {}
                    Item.label = entry.Label;
                    if (entry.Type === 'step' && entry.id){
                        Item.link = `/step/${entry.id}`
                        Section.Items.push(Item);
                    }
                }
                Content.Index.Sections.push(Section);

                this.setLayoutContent(Content)
                localStorage.setItem("dsdContent",JSON.stringify(Content));


            }

            const idProcess = Process._id;
            let ProcessLayout = getProcess(this.dsd, idProcess, onLoad, null, 'layout', 'json');

            Content.Index.title = Process.name;
            Content.Index.link = `/process/${Process._id}`

            Content.Index.Sections = [];

        }


        return;

    }

    loadLeftCodeList(CodeList, offset=0){

        const pageSize = 20;
        let Content = {Index:{}};

        if (CodeList){
            Content.Index.type = 'Code List';
            Content.Index.title = CodeList.name;
            Content.Index.link = `/codelist/${CodeList._id}`;

            Content.Index.Sections = [];

            if (CodeList.Codes){
                const total = CodeList.Codes.length;
                const safeOffset = Math.max(0, Math.min(offset, total - 1));
                const slicedCodes = CodeList.Codes.slice(safeOffset, safeOffset + pageSize);

                let Section = {title: "Items"};
                Section.Items = [];

                for (let posI = 0; posI < slicedCodes.length; posI++){
                    let Code = slicedCodes[posI];
                    let Item = {};
                    Item.label = Code.code;
                    Item.link = `/item/${Code._id}`;
                    Section.Items.push(Item);
                }

                if (total > pageSize){
                    Section.pagination = {
                        idCodeList: CodeList._id,
                        offset: safeOffset,
                        pageSize: pageSize,
                        total: total
                    };
                }

                Content.Index.Sections.push(Section);
            }
        }

        this.setLayoutContent(Content);
        localStorage.setItem("dsdContent", JSON.stringify(Content));

        return;

    }

    loadLeftCodeListVersions(CodeList, Versions){

        let Content = {Index:{}};

        if (CodeList){
            Content.Index.type = 'Code List';
            Content.Index.title = CodeList.name;
            Content.Index.link = `/codelist/${CodeList._id}`

            Content.Index.Sections = [];
            if (Versions){
                let Section = {title: "Versions"};
                Section.Items = [];

                for (const Version of Versions){
                    let Item = {};
                    Item.label = Version.name;
                    Item.link = `/codelist/${CodeList._id}/version/${Version._id}`;
                    Section.Items.push(Item);
                }

                Content.Index.Sections.push(Section);
            }
        }

        this.setLayoutContent(Content)
        localStorage.setItem("dsdContent",JSON.stringify(Content));

        return;

    }

    loadLeftNarrative(Narrative){

        let Content = {Index:{}};

        if (Narrative){
            Content.Index.type = 'Narrative';
            Content.Index.title = Narrative.name;
            Content.Index.link = `/narrative/${Narrative._id}`

            Content.Index.Sections = [];
        }

        this.setLayoutContent(Content)
        localStorage.setItem("dsdContent",JSON.stringify(Content));

        return;

    }

        loadLeftNarrativeVersions(Narrative, Versions){

        let Content = {Index:{}};

        if (Narrative){
            Content.Index.type = 'Narrative';
            Content.Index.title = Narrative.name;
            Content.Index.link = `/narrative/${Narrative._id}`

            Content.Index.Sections = [];
            if (Versions){
                let Section = {title: "Versions"};
                Section.Items = [];

                for (const Version of Versions){
                    let Item = {};
                    Item.label = Version.name;
                    Item.link = `/narrative/${Narrative._id}/version/${Version._id}`;
                    Section.Items.push(Item);
                }

                Content.Index.Sections.push(Section);
            }
        }

        this.setLayoutContent(Content)
        localStorage.setItem("dsdContent",JSON.stringify(Content));

        return;

    }

    setUser(user){

        if (!isEqual(user, this.state.user)){
            this.setState({user:user});
        }
    }


    FeatureMenu(){

        if (this.dsd.config.Features){
            return (
                <div className="designer-sidemenu">
                    <div className="designer-indextitle">
                        <h3>Menu</h3>
                    </div>
                    {this.dsd.config.Features.map(
                        (Feature, posFeature) => 
                        {
                            let classSection = '';
                            if (Feature.highlight){
                                classSection = 'designer-menuHighlight'
                            }
                            return(
                                <p key={posFeature}><PD.PdNavLink to={Feature.link}> {Feature.label}</PD.PdNavLink></p>
                            )
                        })
                    }
                </div>
            )
        }
        return null;
        
    }

    IndexLinks(){

        if (this.state.LayoutContent){
            if (this.state.LayoutContent.Index){
                const Index = this.state.LayoutContent.Index;
                if (Index.title){
                    return (
                        <div className="designer-sidemenu">
                            {Index.title &&
                                <div className="designer-indextitle">

                                    {Index.type &&
                                        <h3>{Index.type}</h3>
                                    }

                                    {(() => {
                                        if (Index.link) {
                                            return(
                                            <p><PD.PdNavLink to={Index.link}> {Index.title}</PD.PdNavLink></p>
                                            )
                                        }
                                        else{
                                            return (<p>{Index.title}</p>)
                                        }
                                    })()}

                                    <div style={{paddingLeft: "20px"}}>
                                        {this.state.LayoutContent.Index.Sections &&
                                            this.state.LayoutContent.Index.Sections.map(
                                                (Section, posSection) => 
                                                {
                                                    let classSection = '';
                                                    if (Section.highlight){
                                                        classSection = 'designer-menuHighlight'
                                                    }
                                                    return(
                                                        <div key={posSection} className={classSection}>

                                                            {(() => {
                                                                if (Section.link) {
                                                                    return(
                                                                    <p><PD.PdNavLink to={Section.link}> {Section.title}</PD.PdNavLink></p>
                                                                    )
                                                                }
                                                                else{
                                                                    return (<p>{Section.title}</p>)
                                                                }
                                                            })()}


                                                            {Section.Items &&
                                                                <ul>
                                                                {Section.Items.map(
                                                                    (Item, posItem) => 
                                                                    {

                                                                        let classItem = '';
                                                                        if (Item.highlight){
                                                                            classItem = 'designer-menuHighlight'
                                                                        }

                                                                        return(
                                                                            <li key={posItem} className={classItem}>
                                                                                {(() => {
                                                                                    if (Item.link) {
                                                                                        return(
                                                                                        <PD.PdNavLink to={Item.link}> {Item.label}</PD.PdNavLink>
                                                                                        )
                                                                                    }
                                                                                    else{
                                                                                        return (<>{Item.label}</>)
                                                                                    }
                                                                                })()}
                                                                            </li>
                                                                        )
                                        
                                                                    }
                                                                )
                                                                }
                                                                </ul>
                                                            }

                                                            {Section.pagination && (
                                                                <div style={{display:'flex', gap:'8px', marginTop:'4px'}}>
                                                                    {Section.pagination.offset > 0 && (
                                                                        <button onClick={() => this.setLeftAsCodeList(Section.pagination.idCodeList, Section.pagination.offset - Section.pagination.pageSize)}>
                                                                            &laquo; Prev
                                                                        </button>
                                                                    )}
                                                                    {(Section.pagination.offset + Section.pagination.pageSize) < Section.pagination.total && (
                                                                        <button onClick={() => this.setLeftAsCodeList(Section.pagination.idCodeList, Section.pagination.offset + Section.pagination.pageSize)}>
                                                                            Next &raquo;
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            )}

                                                        </div>
                                                    )
                                                }
                                            )
                                        }
                                    </div>
                                </div>
                            }
                            <hr/>

                        </div>
                    )
                }
                                        
                return null;
            }

        }

        return <div/>        
    }

    render(){

        return(
            <DesignerLayoutContext.Provider value={{"hasLayout":true, "Layout":this, "Content":this.state.LayoutContent}}>
                <div id="designer-container">
                    <div id="designer-header" key="designer-header">
                        <DesignerHeader content={this.state.LayoutContent} user={this.state.user}/>
                    </div>
                    <div id="designer-wrapper">
                        <div id="designer-leftpane" key="designer-leftpane">
                            <div style={{paddingLeft:"5px"}}>
                                {this.IndexLinks()}
                                {this.FeatureMenu()}
                            </div>
                        </div>
                        <div id="designer-content" key="designer-content">
                            {this.props.children}
                        </div>
                    </div>
                    <div id="designer-footer"  key="designer-footer">
                        <DesignerFooter/>
                    </div>
                </div>
            </DesignerLayoutContext.Provider>
        )
    };
};


class DesignerHeader extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            breadcrumb:null
        }

    }

    componentDidMount(){

        // Load user from localStorage if available
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            try {
                const user = JSON.parse(storedUser);
                this.setState({ user: user });
            } catch (e) {
                console.error('Failed to parse stored user:', e);
            }
        }

        this.setup();
 
     }
 
     componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }
     }


    setup(){


        if (this.props.content){
            if (this.props.content.Breadcrumb){
                  this.setState({breadcrumb:this.props.content.Breadcrumb})
            }
        }

    }

    Breadcrumb(Breadcrumb){

        if (Breadcrumb.Items){

            return (
                <div className="designer-breadcrumb"> 

                    {Breadcrumb.Items.map(
                        (Item, posItem) => 
                        {
                            return(
                                <>
                                    {(() => {
                                        if (Item.link) {
                                            return(
                                                <PD.PdNavLink key={posItem} to={Item.link}> {Item.label}</PD.PdNavLink>
                                            )
                                        }
                                        else{
                                            return (<span key={posItem}>{Item.label}</span>)
                                        }
                                    })()}
                                    {(posItem + 1) < Breadcrumb.Items.length &&
                                        <span key={`span-${posItem}`}> / </span>
                                    }
                                </>
                            )
                        }
                    )
                    }
                </div>
            )
         }
        
    }


    render() {

        let Title = 'Digital Service Designer';
        if (this.props.content){
            if (this.props.content.title){
                Title = this.props.content.title;
            }
        }

        // Use user from props if available, otherwise from state (loaded from localStorage)
        let user = this.props.user || this.state.user;

        return (
            <div>
                <div className="designer-title">
                    <img src={logo} alt="Digital Service Designer" className="designer-logo" />
                    <span>{Title}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', flexDirection: 'column', marginBottom: '0.5em', paddingRight: '10px' }}>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <PD.PdNavLink exact to={"/"} >Home</PD.PdNavLink>
                        {user &&
                            <PD.PdNavLink exact to={"/login"} onClick={(e) => { 
                                userService.logout(); 
                                window.location.href = '/login';
                                e.preventDefault();
                            }} >Logout</PD.PdNavLink>
                        }
                        {!user &&
                            <PD.PdNavLink exact to={"/login"} >Login</PD.PdNavLink> 
                        }
                    </div>
                    {user &&
                        <div style={{ fontSize: '0.85em', color: '#595959', marginTop: '0.3em' }}>
                            Logged on as: {user.organisation}
                        </div>
                    }
                </div>
                <hr/>
                {this.state.breadcrumb &&
                    this.Breadcrumb(this.state.breadcrumb)
                }
            </div>
        )
    };
};



class DesignerFooter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }

    }


    render() {

        return (
            <div>
                <hr/>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1em' }}>
                    <span>Digital Service Designer - version {packageJson.version}</span>
                    <NavLink to="/terms">Terms of Use</NavLink>
                </div>
            </div>
        )

    };
};

export default DesignerContainer;